
















































































import Vue from 'vue';
import ReporteGenerico from '@/components/reporte/ReporteGenerico.vue';
import firstCharsToUpperCase from '@/util/firstCharsToUpperCase';

export default Vue.extend({
  components: {
    ReporteGenerico,
  },
  props: {
    unidadesInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    td: ['unidad', 'propietario', 'saldoAnterior', 'total', 'pagos', 'saldoActual', 'saldoFavor', 'saldoAnteriorFavor', 'aclaracion'],
    cRecibos: [],
    cCobros: [],
    tCobroDialog: false,
    loading: false,
    menu: false,
    formatoFecha: 'MMMM YYYY',
    formatDate: 'DD-MM-YYYY',
    date: '',
    req: {
      start: '',
      end: '',
      unidades: [],
      unidadId: '',
    },
    reporte: {},
    dateHeader: '',
    startOfHeader: '',
    endOfHeader: '',
    dateToday: '',
    condoHeader: {},
  }),
  mounted() {
    this.date = this.$moment().format();
    this.dateToday = this.$moment().format(this.formatDate);
    this.condoHeader = this.$store.getters.getCondo;
  },
  computed: {
    computedDateFormatted() {
      this.dateHeader = this.$moment(this.date).format(this.formatoFecha).toUpperCase();
      this.startOfHeader = this.$moment(this.date).startOf('month').format('D');
      this.endOfHeader = this.$moment(this.date).endOf('month').format('D');
      return firstCharsToUpperCase(this.$moment(this.date).format(this.formatoFecha));
    },
  },
  methods: {
    closeDialog() {
      this.tCobroDialog = false;
    },
    async reportesList() {
      this.cCobros = [];
      this.cRecibos = [];
      this.loading = true;
      const condo = this.$store.getters.getCondo;
      const admin = this.$store.getters.getAdmin;
      this.req.start = this.$moment(this.date).startOf('month').format();
      this.req.end = this.$moment(this.date).endOf('month').format();
      const req = this.req;
      const reporte = await this.$store.dispatch('findReportesPeriodo2', {condo, admin, req});
      // console.debug('Reporte: ', reporte.data);
      this.reporte = reporte.data;
      // let m = 0
      for (const y of this.reporte.headers) {
        const r = this.td.includes(y.value);
        if (!r) {
          const index = y.value.indexOf('Cobro');
          if (index === 0) {
            this.cCobros.push(y.value);
          } else {
            this.cRecibos.push(y.value);
          }
        }
      }
      this.cCobros.sort();
      this.cRecibos.sort();
      this.loading = false;
    },
    print() {
      window.print();
    },
  },
  watch: {
    tCobroDialog() {
      if (this.tCobroDialog) {
        console.log('UNIDADES %o', this.unidadesInit);
        this.req.unidades = this.unidadesInit;
        this.reporte = {};
      }
    },
  },
});
